import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import { apiCall } from "@/core/utils/api";
import { listMeetingModules, toggleMeetingModule } from "@sgdf/client-v2";

export const useModules = () => {
  return useQuery({
    queryKey: ["modules"],
    queryFn: () => apiCall(listMeetingModules()),
    select: (data) => data.items,
  });
};

export const useModuleToggle = () => {
  const meetingId = useMeetingId();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (options: { id: string }) =>
      apiCall(toggleMeetingModule({
        path: { meeting_id: meetingId.value!, module_id: options.id },
      })),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["meetings"],
      });
      queryClient.invalidateQueries({
        queryKey: ["public-meetings", meetingId.value],
      });
    },
  });
};

export const useModule = () => {
  const store = useUserStore();
  const { hasModule } = storeToRefs(store);

  return hasModule;
};
